import Button from "./Button";
import "./Event.css";
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

const Event = (props) => {
  const date = new Date(props.date);
  const day = String(date.getDate()).padStart(2);
  const month = date.toLocaleString("default", { month: "long" });
  const [truncatedDescription, setTruncatedDescription] = useState("");
  const year = String(date.getFullYear());

  const getDescriptionLength = () => {
    if (window.innerWidth < 576) {
      return 100;
    } else if (window.innerWidth < 768) {
      return 150;
    } else if (window.innerWidth < 1200) {
      return 250;
    } else {
      return 400;
    }
  };

  const truncateDescription = useCallback(() => {
    const length = getDescriptionLength();
    setTruncatedDescription(props.overview.slice(0, length) + "...");
  }, [props.overview]);

  useEffect(() => {
    truncateDescription();
    window.addEventListener("resize", truncateDescription);
    return () => {
      window.removeEventListener("resize", truncateDescription);
    };
  }, [truncateDescription]);

  return (
    <div className="d-flex event col-12 col-md-10 col-lg-8">
      <div className="event-text">
        <h3>{props.name}</h3>
        <div className="event-date-tag">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-calendar-days-icon lucide-calendar-days"
          >
            <path d="M8 2v4" />
            <path d="M16 2v4" />
            <rect width="18" height="18" x="3" y="4" rx="2" />
            <path d="M3 10h18" />
            <path d="M8 14h.01" />
            <path d="M12 14h.01" />
            <path d="M16 14h.01" />
            <path d="M8 18h.01" />
            <path d="M12 18h.01" />
            <path d="M16 18h.01" />
          </svg>
          <span>
            {day}. {month} {year}
          </span>
        </div>
        <p>{truncatedDescription}</p>
        <div className="text-end">
          <Link to={`/udalosti/detail/${props.id}`}>
            <Button text="Detail projektu" />
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Event;
